<script>
import Globo from "@/assets/globo.svg";
import ThreadsSvg from "@/assets/threads.svg";
import BlueskySvg from "@/assets/bluesky.svg";
export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    flgExibirUf: Boolean,
    rowwidth: {
      type: String,
      default: "700px",
    },
    texts: {
      type: Object,
      default() {
        return { 0: "ana clara está belissima!", 1: "amando o programa <3" };
      },
    },
    user: {
      type: String,
      default: "@Caio1294",
    },
    hashtag: {
      type: String,
      default: "#PANELAQUENTENOGNT",
    },
    numero: {
      type: String,
      default: "(21)99122-0605",
    },
  },
  components: {
    Globo,
    ThreadsSvg,
    BlueskySvg,
  },
  created() {
    this.breakpoint = this.$vuetify.breakpoint.name;
  },
  computed: {
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.1rem"
          : numChars > 40 && numChars <= 80
          ? "2rem"
          : numChars > 80 && numChars <= 120
          ? "1.9rem"
          : numChars > 120 && numChars <= 160
          ? "1.8rem"
          : numChars > 160 && numChars <= 200
          ? "1.7rem"
          : numChars > 200 && numChars <= 240
          ? "1.6rem"
          : numChars > 240 && numChars <= 280
          ? "1.55rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.4rem"
          : numChars > 40 && numChars <= 80
          ? "2.2rem"
          : numChars > 80 && numChars <= 120
          ? "2rem"
          : numChars > 120 && numChars <= 160
          ? "1.85rem"
          : numChars > 160 && numChars <= 200
          ? "1.75rem"
          : numChars > 200 && numChars <= 240
          ? "1.65rem"
          : numChars > 240 && numChars <= 280
          ? "1.55rem"
          : "1.5rem";

      return lineHeight;
    },
  },
};
</script>

<template>
  <v-container
    class="row-width mb-16"
    :class="{
      'ma-auto midia-card': ['video', 'image'].includes(item?.dsc_tipo_midia_colaboracao),
      card:
        !item?.dsc_tipo_midia_colaboracao || item?.dsc_tipo_midia_colaboracao === 'audio',
    }"
    :style="
      isFullScreen
        ? 'justify-self: center'
        : posicaoCard === 'esquerda'
        ? 'margin-left: 64px; justify-self: flex-start'
        : posicaoCard === 'centro'
        ? 'justify-self: center'
        : posicaoCard === 'direita'
        ? 'margin-right: 64px; justify-self: flex-end'
        : 'margin-left: 64px; justify-self: flex-start'
    "
  >
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="card-bg-blue pa-0 ma-0 card-text-blue">
        <div class="d-flex">
          <div class="icon d-flex ma-0 pa-0 py-2 px-1 align-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
              v-if="item.dsc_fonte_colaboracao === 'twitter'"
            >
              <g id="surface1">
                <path
                  style="
                    stroke: none;
                    fill-rule: nonzero;
                    fill: rgb(6, 87, 153);
                    fill-opacity: 1;
                  "
                  d="M 22.804688 2.8125 L 26.941406 2.8125 L 17.90625 13.136719 L 28.535156 27.1875 L 20.214844 27.1875 L 13.695312 18.667969 L 6.242188 27.1875 L 2.097656 27.1875 L 11.757812 16.140625 L 1.570312 2.8125 L 10.101562 2.8125 L 15.988281 10.601562 Z M 21.351562 24.714844 L 23.640625 24.714844 L 8.851562 5.15625 L 6.390625 5.15625 Z M 21.351562 24.714844 "
                />
              </g>
            </svg>
            <v-icon
              size="30"
              v-else-if="
                item.dsc_fonte_colaboracao === 'whatsapp' ||
                item.dsc_fonte_colaboracao === 'instagram'
              "
              color="rgb(6, 87, 153)"
              >{{ `mdi-${item.dsc_fonte_colaboracao}` }}
            </v-icon>
            <ThreadsSvg
              v-else-if="item.dsc_fonte_colaboracao === 'threads'"
              style="fill: rgb(6, 87, 153); width: 30px; height: 30px"
            />
            <BlueskySvg
              v-else-if="item.dsc_fonte_colaboracao === 'bluesky'"
              style="fill: rgb(6, 87, 153); width: 30px; height: 30px"
            />
            <Globo class="globo-svg" v-else></Globo>
          </div>

          <div class="user d-flex flex-grow-1 pl-2 align-center card-bg-red">
            <h4 class="user-text text-uppercase text-left card-text-blue">
              {{ item.dsc_nome_colaborador }}
            </h4>
          </div>
          <div class="hashtag d-flex px-2 align-center card-bg-blue">
            <h4 class="hashtag-text text-uppercase text-left card-text-yellow">
              {{ item.dsc_fonte_colaboracao === "whatsapp" ? numero : hashtag }}
            </h4>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="card-bg-pink pa-0 ma-0 flex-row">
      <v-col
        v-if="!!!item?.dsc_tipo_midia_colaboracao"
        cols="12"
        class="d-flex align-center principal-text ma-0 pa-0 py-4 px-8"
      >
        <p
          class="card-text-blue-dark"
          :style="{
            lineHeight: lineHeight,
            fontSize: bodyTextSize,
            wordBreak: 'break-word',
          }"
        >
          {{ item.dsc_texto_colaboracao }}
        </p>
      </v-col>
      <v-col v-if="!!item?.dsc_tipo_midia_colaboracao">
        <div style="width: 100%" class="d-flex align-center">
          <template v-if="item.dsc_tipo_midia_colaboracao === 'image'">
            <v-img
              :src="item.url_midia_colaboracao"
              contain
              width="100%"
              height="100%"
              style="max-height: 80vh"
            />
          </template>
          <template v-if="item.dsc_tipo_midia_colaboracao === 'video'">
            <video
              :key="item.url_midia_colaboracao"
              ref="videoPlayer"
              style="max-height: 80vh"
              width="100%"
              height="100%"
              autoplay
              @playing="() => this.$emit('played', this.$refs.videoPlayer)"
            >
              <source :src="item.url_midia_colaboracao" type="video/mp4" />
            </video>
          </template>
          <template v-if="item.dsc_tipo_midia_colaboracao === 'audio'">
            <audio
              autoplay
              style="width: 100%"
              class="mt-4"
              controls
              :key="item.url_midia_colaboracao"
            >
              <source :src="item.url_midia_colaboracao" />
            </audio>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
@font-face {
  font-family: "Aku&Kamu";
  src: url("@/assets/Aku&Kamu.otf") format("opentype");
}
$time: 1s;
$custom-letter-spacing: 0.05rem;

.globo-svg {
  width: 30px;
  height: 30px;
  stop {
    stop-color: #edb739;
  }
}
.card {
  padding: 0;
  margin: 0;
  overflow: hidden;
  width: v-bind(rowwidth);
  // animation: aumentarTamanhoDiv $time ease;
}

.midia-card {
  width: 70%;
}

.icon {
  // animation: movimentoIcone $time ease;
}

.user {
  overflow-x: hidden;
  // animation: maovimentoIcone $time ease;
}

.hashtag {
  overflow-x: hidden;
  // animation: maovimentoIcone $time ease;
}

.user-text {
  font-family: "Aku&Kamu";
  letter-spacing: $custom-letter-spacing;
  font-size: 1.8em;
  // animation: aumentarEspacamentoLetra $time ease;
}

.hashtag-text {
  font-family: "Aku&Kamu";
  letter-spacing: $custom-letter-spacing;
  font-size: 1.8em;
  // animation: aumentarEspacamentoLetra $time ease;
}

.principal-text {
  overflow: hidden;
  width: 100%;
  height: 12rem;
  line-height: 1.6rem;
  letter-spacing: $custom-letter-spacing;
  font-size: 1.7rem;
  font-weight: 800;

  p {
    margin: 0;
    padding: 0;
    // animation: aumentarEspacamentoLetra $time ease;
  }
}

.card-bg-pink {
  background-color: #f877e2;
}

.card-bg-blue {
  background-color: rgb(33, 162, 206);
}

.card-text-blue {
  color: rgb(33, 162, 206);
}

.card-text-yellow {
  color: rgb(6, 87, 153);
}

.card-text-blue-dark {
  color: #444791 !important;
}

.card-bg-red {
  background-color: #c70000;
  //width: 35%;
}

@keyframes aumentarTamanhoDiv {
  0% {
    margin-left: 100px;
    padding-left: 200px;
  }
  50% {
    margin-left: -30px;
    padding-left: 0px;
  }
  100% {
    margin-left: 0px;
    padding-left: 0px;
  }
}

@keyframes aumentarEspacamentoLetra {
  0% {
    letter-spacing: 0.2rem;
  }
  100% {
    letter-spacing: $custom-letter-spacing;
  }
}

@keyframes movimentoIcone {
  0% {
    margin-right: 30px;
  }
  50% {
    padding-left: 30px;
    margin-right: -10px;
  }
  100% {
    padding-left: 0px;
  }
}

@keyframes movimentoDireita {
  0% {
    padding-left: 30px;
  }
  100% {
    padding-left: 0px;
  }
}
</style>
